import './lib/sentryClient'; // sentryの初期化は最初にimportする
import './App.css';
import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';
import * as Sentry from '@sentry/react';
import { Button } from '@/components/Elements/Button';
import { Amplify } from 'aws-amplify';
import config from '@/amplifyconfiguration.json';

Amplify.configure(config);

const ErrorFallback = () => (
  <div className="text-red-500 w-screen h-screen flex flex-col justify-center items-center" role="alert">
    <h2 className="text-lg font-semibold">Ooops, something went wrong :( </h2>
    <Button className="mt-4" onClick={() => window.location.assign(window.location.origin)}>
      Refresh
    </Button>
  </div>
);

const App = () => (
  <Sentry.ErrorBoundary fallback={ErrorFallback}>
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  </Sentry.ErrorBoundary>
);

export default App;
